"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _theme = require("../theme");
require("./button.css");
var _excluded = ["children", "className", "color", "href", "loading", "tagName", "type", "interactive", "onClick", "visualStyle"];
/* eslint-disable max-statements */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var isReactComponent = function isReactComponent(component) {
  var _component$prototype;
  return typeof component === 'function' && (String(component).includes('return React.createElement') || Boolean((_component$prototype = component.prototype) === null || _component$prototype === void 0 ? void 0 : _component$prototype.isReactComponent));
};

/**
 * This component renders `button` tags by default or `a` if `href` is
 * provided. It also supports an arbitrary `tagName` prop for advanced usage, which can
 * support HTML tag names or React components like `Link`.
 */
var Button = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    className = props.className,
    color = props.color,
    href = props.href,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    tagName = props.tagName,
    _props$type = props.type,
    type = _props$type === void 0 ? 'button' : _props$type,
    _props$interactive = props.interactive,
    interactive = _props$interactive === void 0 ? true : _props$interactive,
    onClick = props.onClick,
    _props$visualStyle = props.visualStyle,
    visualStyle = _props$visualStyle === void 0 ? 'default' : _props$visualStyle,
    otherProps = _objectWithoutProperties(props, _excluded);
  var tagNameRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, function () {
    return tagNameRef.current;
  });
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    timer = _useState2[0],
    setTimer = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showLoading = _useState4[0],
    setShowLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    height = _useState6[0],
    setHeight = _useState6[1];
  var _useState7 = (0, _react.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    style = _useState8[0],
    setStyle = _useState8[1];
  (0, _react.useEffect)(function () {
    var _tagNameRef$current;
    if ((_tagNameRef$current = tagNameRef.current) !== null && _tagNameRef$current !== void 0 && _tagNameRef$current.offsetHeight) {
      setHeight(tagNameRef.current.offsetHeight);
    }
    return function () {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (loading !== showLoading) {
      setTimer(setTimeout(function () {
        return setShowLoading(!showLoading);
      }, 100));
      if (loading) {
        setStyle({
          width: height,
          height: height
        });
      } else {
        setStyle({
          height: height
        });
      }
    }
  }, [loading, showLoading]);
  var TagName = tagName || (href ? 'a' : 'button');
  var buttonType = TagName !== 'button' && TagName !== 'input' ? null : type;
  var notInteractive = Boolean(!['button', 'a', 'input'].includes(TagName) && !isReactComponent(tagName) || !interactive);
  var textOnly = visualStyle === 'textOnly';
  var textLink = visualStyle === 'textLink';
  var textLinkClass = "sb-textLink ".concat(className || '');
  var buttonOnClick = loading && !textOnly && !textLink ? function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
  } : onClick;
  var renderLoadingCircle = function renderLoadingCircle() {
    return showLoading && !otherProps.disabled ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "sb-button--loadingCircle"
    }) : null;
  };
  return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
    var classList = textLink ? textLinkClass : (0, _classnames["default"])('sb-button', _defineProperty({
      'sb-button--default': visualStyle === 'default',
      'sb-button--positive': visualStyle === 'positive',
      'sb-button--text': visualStyle === 'textOnly',
      'sb-button--disabled': Boolean(otherProps.disabled),
      'sb-button--darkTheme': theme === _theme.themes.dark,
      'sb-button--rewardsDefault': theme === _theme.themes.rewards,
      'sb-button--gold': color === 'gold',
      'sb-button--black': color === 'black',
      'sb-button--white': color === 'white',
      'sb-button--houseGreen': color === 'houseGreen',
      'sb-button--loading': Boolean(loading && !otherProps.disabled && !textOnly),
      'sb-button--nonInteractive': notInteractive
    }, className, Boolean(className)));
    return /*#__PURE__*/_react["default"].createElement(TagName, _extends({
      className: classList,
      href: href,
      onClick: buttonOnClick,
      ref: tagNameRef,
      style: _objectSpread({
        minWidth: height,
        minHeight: height
      }, style),
      type: buttonType
    }, otherProps), loading && !textLink && !textOnly && renderLoadingCircle(), (!loading || otherProps.disabled || textLink || textOnly) && children);
  });
});
Button.displayName = 'Button';
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  /* Optional color for the button. By default, green buttons are used. Black buttons will be used
   * automatically if the button is in the Rewards Theme. White will be used automatically if the button is
   * in the Dark Theme. White and gold buttons should be used cautiously,
   * as they introduce contrast/accessibility issues with many background colors.
   */
  color: _propTypes["default"].oneOf(['gold', 'black', 'white', 'houseGreen']),
  /** The href of the link */
  href: _propTypes["default"].string,
  /**
   * If true, it shows a loading animation inside the button. Not shown if it's a text-only or text link button
   * or if the button is disabled.
   */
  loading: _propTypes["default"].bool,
  /**
   * The visual style of the button.
   */
  visualStyle: _propTypes["default"].oneOf(['default', 'positive', 'textLink', 'textOnly']),
  /**
   * An optional HTML tagname or React component for the rendered element. This should generally be
   * `button` or `a`, unless there's a good reason to make it a non-interactive element. Defaults
   * to `button`, or `a` if an `href` is present.
   */
  tagName: _propTypes["default"].any,
  /**
   * An HTML button
   * [`type` attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button).
   * Only applied if the `tagName` is `button` or `input`.
   */
  type: _propTypes["default"].oneOf(['button', 'reset', 'submit']),
  interactive: _propTypes["default"].bool
} : {};
var _default = exports["default"] = Button;